import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { Redirect } from "react-router-dom";
import { withFormik } from "formik";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import _ from 'lodash';
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import queryString from 'query-string';
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { changePasswordRequest } from "store/state/changePassword";
import { validationSchema } from "shapes/changePassword";
import { withStyles } from "@material-ui/core/styles";
import {ROUTE_DASHBOARD, ROUTE_GUEST_LANDING} from 'constants/routes';

const styles = {
  root: {
    background: "transparent"
  },
  input: {
    color: "#333",
    fontWeight: "100",
    backgroundColor: "#fff",
    fontFamily: "Roboto"
  },
  divider: {
    backgroundColor: "#fff",
    marginBottom: "10px",
    marginTop: "10px"
  },
  white: {
    color: "#fff",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  blue: {
    color: "#0f90d0",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  caption: {
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    fontFamily: "Roboto"
  },
  boldText: {
    fontWeight: "900"
  },
  button: {
    backgroundColor: "rgba(15, 144, 208, 1)",
    color: "#fff",
    width: "100px",
    borderRadius: "20px",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "rgba(15, 144, 208, .7)"
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    marginBottom: "5px"
  }
};

export class ChangePassword extends Component {
  state = {
    animate: false,
    touched: false,
    token: null,
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({  animate: true });
    }, 500);
  }

  hasGuestOnlyAccess = () => this.props.authentication && this.props.authentication.guestAccess==="guest"

  render() {
    const {
      classes,
      loading,      
      authentication,
      handleChange,
      handleSubmit,
      values,
      errors,
      touched
    } = this.props;

    const { authed } = authentication;    
    
    if (!loading.authentication && authed) {
      let authRedirectProps = JSON.parse(localStorage.getItem('authRedirect'));      
      let path = this.hasGuestOnlyAccess() ? ROUTE_GUEST_LANDING : ROUTE_DASHBOARD;
      let potentialPath = _.get(authRedirectProps, 'computedMatch.url');            
      if(potentialPath){
        path = potentialPath;  
        localStorage.removeItem('authRedirect');
      }
      return <Redirect to={path} />;
    }
    return (
      <Fragment>
        <Grid className="login_Panel" container spacing={24}>
          <Grid item xs={12} className="login_PanelInner">
            <Paper
              className={`login_PanelInnerPaper shouldAnimate ${
                this.state.animate ? "animateDownFadeIn" : ""
              }`}
            >
              <form
                onSubmit={handleSubmit}
                id="login_no_human"
                autoComplete="new-password"
              >
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <Typography
                      variant="display3"
                      className={`${classes.white} robotText`}
                    >
                      DEBT.
                    </Typography>
                    <Typography
                      variant="display3"
                      className={`${classes.blue} robotText`}
                    >
                      SMARTER.
                    </Typography>
                    <Divider className={classes.divider} />
                    <Typography
                      className={`${classes.caption} ${classes.boldText}`}
                      variant="body2"
                    >
                      Enter New Password
                    </Typography>
                    <Typography
                      className={classes.caption}
                      gutterBottom
                      variant="caption"
                    >
                      Please ensure your password is at least 8 characters.
                    </Typography>
                    <FormControl
                      fullWidth
                      error={errors.password && touched.password}
                    >
                      <Typography variant="body1" className={classes.label}>
                        New Password
                      </Typography>
                      <Input
                        id="password"
                        className={classes.input}
                        type="password"
                        value={values.password}
                        onChange={handleChange}
                        placeholder="Enter password"
                      />
                      {errors.password &&
                        touched.password && (
                          <FormHelperText id="name-error-text">
                            {errors.password}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      error={errors.confirmPassword && touched.confirmPassword}
                    >
                      <Typography variant="body1" className={classes.label}>
                        Confirm New Password
                      </Typography>
                      <Input
                        id="confirmPassword"
                        className={classes.input}
                        type="password"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        placeholder="Re-enter password"
                      />
                      {errors.confirmPassword &&
                        touched.confirmPassword && (
                          <FormHelperText id="name-error-text">
                            {errors.confirmPassword}
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <Button
                        type="submit"
                        size="large"
                        className={classes.button}
                        id="submitButton"
                      >
                        Save
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, loading }) => ({
  authentication,
  loading
});

export default compose(
  withLDConsumer(),
  connect(
    mapStateToProps,
    { changePasswordRequest }
  ),
  withFormik({
    mapPropsToValues: () => ({ password: "", confirmPassword: "" }),
    validationSchema,
    handleSubmit: (values, { props }) => {
      const { location } = props;
      let params = queryString.parse(location.search, {arrayFormat: 'bracket'});
      const data = { ...values, token: params.token };
      props.changePasswordRequest(data);
    },
    displayName: "ChangePasswordForm"
  }),
  withStyles(styles)
)(ChangePassword);
